import { Header } from '../components/Header';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReadMeModal from './ReadMeModal';


import axios from 'axios';
import {
  CLIENT_ID,
  CLIENT_SECRET,
  DATA_DECRYPTION_KEY,
  CDN_ELK_URL,
  BASE_URL_API,
  BASE_URL_OPENFORGE
} from '../components/Constants';
import crypto from 'crypto-js';
import { decryptAES } from '../components/CryptoUtils';
import { useLocation } from "react-router-dom";
import { useUser } from '../ContextApi/UserContext';
import 'toastify-js/src/toastify.css';
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const RepoDetail = React.memo(() => {
  const location = useLocation();
  const { user, isLoggedIn} = useUser();
  const id = useParams(); // Get the dynamic ID from the route
  const [isLoading, setIsLoading] = useState(false);
  //newCode for useNavigate
  // const [task, setTask] = useState(location?.state?.task || {});
  //API Task State Previous Code
  const [task, setTask] = useState([]);
  const [downloadCount,setDownloadCount] = useState(0);
  const [showModal, setShowModal] = useState(false)


  function transformData(inputArray) {

    const fetch_records = inputArray.data.map((record) => ({
      artifact_id: record.artifact_id,
      title: { label: "Title", value: [record["component_title"]] },
      tracker_id: record.tracker_id,
      status: { label: "Status", value: [record.status] },
      short_description: { label: "Short Description", value: [record.short_description] },
      full_description: { label: "Full Description", value: [record.full_description] },
      usage: { label: "Usage", value: [record.usage] },
      code_content: { label: "Code Content", value: [record.code_content || ""] },
      component_added_by: { label: "Added By", value: [record.component_added_by] },
      component_added_date: { label: "Added On", value: [record.component_added_date] },
      technology_used: {
        label: "Technology Used",
        value: record.technology_used.split(',').map(item => item.trim())
      },
      repository_url: { label: "Repository URL", value: [record.git_repository_url] },
      readme: { label: "README", value: [record.readme || ""] },
      timestamp: { label: "Timestamp", value: [record["@timestamp"]] },
    }));

    return {
      fetch_records,
      total_records: inputArray.length,
    };
  }


  useEffect(()=>{

    const handleDownloadCount = async () =>{

      try {
        setIsLoading(true);

        const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

        const hmacStr = CLIENT_SECRET + CLIENT_ID + id.id.toString() + ts.toString();
        const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);

        const formData = new FormData();
        formData.append('artifact_id', id.id);
        formData.append('client_id', CLIENT_ID);
        formData.append('ts', ts);
        formData.append('hmac', hmacHash);
        const downloadResult = await axios.post(`${BASE_URL_API}artifact/details`, formData);
        if (downloadResult.data.code === 200) {
          if (downloadResult.data.secure) {
            const encryptedData = await downloadResult.data.data;
            const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
            const output = await JSON.parse(decryptedText); // Assuming decrypted data is JSON
            setIsLoading(false);
            setDownloadCount(output[0].repo_clone_log_count);
          } else {
            setIsLoading(false);
            setDownloadCount(0);
          }


        } else {
          setIsLoading(false);
          setDownloadCount(0);
        } 
      } catch (error) {
        setDownloadCount(0)
        setIsLoading(false);
        console.error("There was a problem fetching the tasks:", error);   
      }
    }

    handleDownloadCount();

  },[])


  // Trigger handleRecords when sortValue changes

  useEffect(() => {
    const handleTaskRecords = async () => {
      try {

        setIsLoading(true);

        const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

        const hmacStr = CLIENT_SECRET + CLIENT_ID + id.id.toString() + ts.toString();
        const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);

        //Previos Code Data Coming From Fast API
        //   const formData = new FormData();
        //   formData.append('artifact_id', id.id);
        //   formData.append('client_id', CLIENT_ID);
        //   formData.append('ts', ts);
        //   formData.append('hmac', hmacHash);

        //   const result = await axios.post(`${BASE_URL_API}artifact/details`, formData);

        //New code CDN API Calling
        const artifactId = [id.id]
        //New code CDN API Calling
        const advanceFilter = JSON.stringify({
          artifact_id: artifactId
        })
        //New code CDN API Calling
        const queryParams = {
          limit: 1,
          offset: 0,
          order_by: "desc",
          advance_filter: advanceFilter,
          client_id: CLIENT_ID,
          ts: ts,
          hmac: hmacHash
        };
        //New code CDN API Calling
        const queryString = new URLSearchParams(queryParams).toString();
        //New code CDN API Calling
        const result = await axios.get(`${CDN_ELK_URL}/elk/reusable_components?${queryString}`);

        if (result.data.code === 200) {
          if (result.data.secure) {
            const encryptedData = await result.data.data;
            const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
            //New code CDN API Calling
            const flattenData = await JSON.parse(decryptedText); // Assuming decrypted data is JSON
            const output = transformData(flattenData)
            setIsLoading(false);
            setTask(output.fetch_records[0]);
            //Previous Code
            //   const output = JSON.parse(decryptedText); // Assuming decrypted data is JSON
            //   console.log("output 152", output);
            //   setIsLoading(false);
            //   setTask(output[0]);
          } else {

            setIsLoading(false);
            setTask(result.data.data[0]);
          }

          // console.log("Task", task)

        } else {
          setIsLoading(false);
          setTask([]);
          //throw new Error(`API returned non-200 code: ${result.code}`);
        }
      } catch (error) {
        setIsLoading(false);
        setTask([]);
        console.error("There was a problem fetching the tasks:", error);
      }
    };

    handleTaskRecords();
  }, [id.id]);


  const handleRedirect = () => {
    const fullRepoUrl = task?.repository_url?.value?.[0]; 
    const domainToRemove = "https://openforge.gov.in";
    const relativeRepoUrl = fullRepoUrl?.startsWith(domainToRemove)
    ? fullRepoUrl.replace(domainToRemove, "")
    : fullRepoUrl;

    if (!isLoggedIn) {
      if (relativeRepoUrl) {
       localStorage.setItem("redirectUrl", relativeRepoUrl);
      }
      window.location.href = `${BASE_URL_OPENFORGE}/account/login.php?requested_by=collabwithgov`;
    } else {
      if (fullRepoUrl) {
        window.location.href = fullRepoUrl; 
      } else {
        alert("Repository URL not available.");
      }
    }
  };
  useEffect(() => {
  window.scrollTo(0, 0); // Scroll to top on mount
  }, []);

  // console.log("rrr", task.status.value)
  return (
    <>
      <Header />
      <main style={{ marginTop: '60px' }}>
        <div className="repodetail-bg">
          <div className='repodetail-breadcrumb'

          >
            <span className='repodetail-breadcrumb-home'>Home</span>
            <span style={{ margin: '0 8px' }}>/</span>
            {
              (task.hasOwnProperty('title') && task.title.hasOwnProperty('value') && task.title.value.length > 0)
                ? task.title.value.map((level, idx) => (
                  <span key={`breadcrumb-${idx}`} className='repodetail-breadcrumb-title'>
                    {level}
                  </span>
                )) : <span>Untitled</span>
            }
          </div>

          <div className='repodetail-header-row'>
            <div>
              {
                (task.hasOwnProperty('title') && task.title.hasOwnProperty('value') && task.title.value.length > 0)
                  ? task.title.value.map((level, idx) => (
                    <span key={`level-${idx}`}>{level}</span>
                  )) : ''
              }
            </div>
            <div>
              <button className='repodetail-header-btn' onClick={handleRedirect}>View Repository</button>
            </div>
          </div>
          <div style={{
            paddingInline: '50px',
            paddingTop: '20px',
            paddingBottom: '30px',
          }}>
            {
              (task.hasOwnProperty('short_description') && task.short_description.hasOwnProperty('value') && task.short_description.value.length > 0)
                ? task.short_description.value.map((level, idx) => (
                  <span key={`level-${idx}`}>{level}</span>
                )) : ''
            }

          </div>
        </div>
        <div className="mb-3 container" id="detail">

          {
            (isLoading)
              ?
              <SkeletonTheme baseColor="#ebebeb" highlightColor="#fff">
                <div className="row">
                  <Skeleton count={5} />
                  <div className="d-flex align-items-center justify-content-center">
                    <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                    <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                    <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                  </div>
                </div>
              </SkeletonTheme>
              :
              <div >


                <div
                  className="mt-4 repodetail-content-row"

                >
                  <div
                    className="card repodetail-card-main"
                  >
                    <div
                      className='repodetail-card-header'
                      style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingBottom: '0.5rem' }}
                    >
                      <button
                        onClick={() => setShowModal(true)}
                        className='repodetail-readme-btn'
                      >
                        Readme
                      </button>
                    </div>

                    {(task?.title?.value?.length > 0) && (
                      <div className='repodetail-title ' style={{ paddingTop: '0' }}>
                        {task.title.value.map((val, idx) => (
                          <span key={`title-${idx}`}>{val}</span>
                        ))}
                      </div>
                    )}
                    <strong className='repodetail-submission-label'>Description:</strong>{' '}

                    {(task?.full_description?.value?.length > 0) && (
                      <div className='repodetail-long-desc'>
                        {task.full_description.value.map((val, idx) => (
                          <div
                            key={`long-${idx}`}
                            dangerouslySetInnerHTML={{ __html: val }}
                          />))}
                      </div>
                    )}
                    <strong className='repodetail-submission-label'>Usage:</strong>{' '}

                    {(task?.usage?.value?.length > 0) && (
                      <div className='repodetail-long-desc'>
                        {task.usage.value.map((val, idx) => (
                          <div
                            key={`long-${idx}`}
                            dangerouslySetInnerHTML={{ __html: val }}
                          />))}
                      </div>
                    )}
                    <div className='repodetail-tech-label'>
                      Technologies:
                    </div>
                    <div
                      className="tags repodetail-tags-list"
                    >
                      <ul>                                {
                        (task.hasOwnProperty('technology_used') && task.technology_used.hasOwnProperty('value') && task.technology_used.value.length > 0)
                          ? task.technology_used.value.map((level, idx) => (
                            <li key={`level-${idx}`}>{level}</li>
                          )) : ''
                      }
                      </ul>
                    </div>
                    <p>
                      <strong className='repodetail-submission-label'>Added On:</strong>{' '}
                      {task?.component_added_date?.value?.length > 0
                        ? (() => {
                          const date = new Date(task.component_added_date.value[0]);
                          const formattedDate = `${('0' + date.getDate()).slice(-2)}-${('0' + (date.getMonth() + 1)).slice(-2)}-${date.getFullYear()}`;
                          return <span>{formattedDate}</span>;
                        })()
                        : 'N/A'}
                    </p>
                    {/* {(task?.component_added_by?.value?.length > 0) && (
                      <p>
                        <strong className='repodetail-submission-label'>Submitted By:</strong>{' '}
                        {task.component_added_by.value.map((name, idx) => (
                          <span key={`submitted-by-${idx}`}>{name}</span>
                        ))}
                      </p>
                    )} */}
                  </div>
                  <div
                    className='repodetail-side-col'
                  >
                    <div
                      className="card repodetail-card"
                    >
                      <h4>
                        Activity Overview
                      </h4>

                      <div style={{ marginBottom: '8px' }}>
                        Download:<span>{downloadCount}</span>
                      </div>
                      <div>
                        Component: <span>{task.hit || 0}</span>
                      </div>
                    </div>
                    <div
                      className="card repodetail-card"
                    >
                      <h4>
                        Tags
                      </h4>
                      <div
                        className="tags repodetail-tags"
                      >
                        {(task.hasOwnProperty('technology_used') && task.technology_used.value && task.technology_used.value.length > 0)
                          ? task.technology_used.value.map((skill, idx) => (
                            <span className='repodetail-tag'
                              key={idx}
                            >
                              {skill}
                            </span>
                          ))
                          : ''
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          }
        </div>
      </main>
      {showModal && (
        <ReadMeModal
          task={task}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  )
});